import { render, staticRenderFns } from "./SetIndexModal.vue?vue&type=template&id=6c292c65&"
import script from "./SetIndexModal.vue?vue&type=script&lang=js&"
export * from "./SetIndexModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports